import './styles.scss';

import { IconExternalLink } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Logo } from '@assets/logo/M_WHITE_LOGO_FULL.svg';

import { Button, Text } from '@fragments';
import { DownloadAppModal } from '@features/downloadApp';

/**
 * Public /download landing, shell-less. On a phone it only shows while the
 * store redirect fires (plus a manual button in case it's blocked); on a
 * computer the QR modal sits over this canvas.
 */
export default function DownloadAppView({ redirecting, openStore, onClose }) {
    const { t } = useTranslation('common');

    return (
        <div className="download-app-page">
            <header className="download-app-page__brand">
                <Logo className="download-app-page__logo" />
            </header>

            <main className="download-app-page__main">
                {redirecting ? (
                    <div className="download-app-page__redirect">
                        <Text.h4 weight={500} contrast={9}>{t('downloadApp.redirecting')}</Text.h4>
                        <Text.span contrast={6}>{t('downloadApp.redirectHint')}</Text.span>
                        <Button
                            color="inverse"
                            variant="rounded"
                            endIcon={<IconExternalLink />}
                            onClick={openStore}
                            preventLoading
                        >
                            {t('downloadApp.openStore')}
                        </Button>
                    </div>
                ) : (
                    <DownloadAppModal open onClose={onClose} />
                )}
            </main>
        </div>
    );
}
